<template>
    <v-container
            id="stores"
            fluid
            tag="section"
    >
        <v-row>
            <v-col class="text-center" cols="12" sm="6" lg="9">
                <StoresFilters @onStoreFiltersChanged="onStoreFiltersChanged"/>
            </v-col>
            <v-col class="text-center" cols="12" sm="6" lg="3">
                <v-btn outlined color="green"
                       to="stores/new"
                >
                    <v-icon left dark>mdi-plus-circle</v-icon>
                    Ajouter une boutique
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
                :options.sync="options"
                :loading="loading"
                :loading-text="$t('global.loading')"
                :items="stores"
                :server-items-length="totalStores"
                :headers="headers"
                :footer-props="footerProps"
                :no-data-text="$t('global.no_data')"
        >

            <template v-slot:item.address="{ item }">
                <template v-if="item.address.line1">{{item.address.line1}}<br/></template>
                <template v-if="item.address.line2">{{item.address.line2}}<br/></template>
                <template v-if="item.address.state">{{item.address.state}}<br/></template>
                <template v-if="item.address.postal_code">{{item.address.postal_code}}<br/></template>
                <template v-if="item.address.country">{{item.address.country}}</template>
            </template>

            <template v-slot:item.short_name="{ item }">
                <v-btn small
                       icon
                       target="_blank"
                       :href="getMarketplaceUrl(item)"
                >
                    <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
            </template>

            <template v-slot:item.owner.enabled="{ item }">
                <template v-if="item.owner.enabled">{{ $t('global.yes') }}</template>
                <template v-else>{{ $t('global.no') }}</template>
            </template>

            <template v-slot:item.stats_products_pending_price_amount="{ item }">
                {{ item.stats_products_pending_price_amount | toCurrency}}
            </template>
            <template v-slot:item.stripe_balance_amount="{ item }">
                {{ item.stripe_balance_amount | toCurrency}}
            </template>
            <template v-slot:item.stripe_total_payout_amount="{ item }">
                {{ item.stripe_total_payout_amount | toCurrency}}
            </template>

            <template v-slot:item.vacancy_start_datetime="{ item }">
                {{ item.vacancy_start_datetime | momentDateSimple}}
            </template>
            <template v-slot:item.vacancy_end_datetime="{ item }">
                {{ item.vacancy_end_datetime | momentDateSimple}}
            </template>

            <template v-slot:item.menu="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                                :to="`/admin/stores/${item.id}`"
                        >
                            <v-list-item-title>{{ $t('stores.view_store') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <v-fab-transition>
            <v-btn
                    to="stores/new"
                    color="primary"
                    fab
                    dark
                    small
                    fixed
                    bottom
                    right
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-container>
</template>

<script>
    import StoresFilters from "../components/StoresFilters";
    import {createQueryString} from "../../../helpers/createQueryString";

    export default {
        name: 'Store.List',
        components: {StoresFilters},
        data() {
            return {
                loading: false,
                headers: [
                    {text: this.$i18n.t('global.name'), value: 'name', sortable: false},
                    {text: this.$i18n.t('global.kind'), value: 'kind', sortable: false},
                    {text: this.$i18n.t('global.link'), value: 'short_name', sortable: false},
                    {text: this.$i18n.t('global.address'), value: 'address', sortable: false},
                    {text: this.$i18n.t('global.email'), value: 'email', sortable: false},
                    {text: this.$i18n.t('global.phone'), value: 'phone', sortable: false},
                    {text: this.$i18n.t('global.stripe_id'), value: 'stripe_account_id', sortable: false},
                    {text: 'A venir', value: 'stats_products_pending_price_amount', sortable: false},
                    {text: 'Disponible', value: 'stripe_balance_amount', sortable: false},
                    {text: 'Total', value: 'stripe_total_payout_amount', sortable: false},
                    {text: 'Vacances (début)', value: 'vacancy_start_datetime', sortable: false},
                    {text: 'Vacances (fin)', value: 'vacancy_end_datetime', sortable: false},
                    {text: this.$i18n.t('global.enabled'), value: 'owner.enabled', sortable: false, align: 'center'},
                    {text: '', value: 'menu', sortable: false, width: '50px'},
                ],

                footerProps: {'items-per-page-options': [30], 'show-first-last-page': true},
                filters: {
                    name:'',
                    email: ''
                },
                options: {
                    page: 1,
                    itemsPerPage: 30,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false,
                },
                stores: [],
                totalStores: 0,
            };
        },

        methods: {
            getMarketplaceUrl(store) {
                return process.env.VUE_APP_MARKETPLACE_URL + store.marketplace_url;
            },
            load() {
                this.loading = true;
                this.stores = [];

                let params = {page: this.options.page, ...this.$route.params, ...this.$route.query, ...this.filters, order: {}};
                // Define sorting parameters.
                if (this.options.sortBy.length) {
                    params.order[this.options.sortBy[0]] = this.options.sortDesc[0] ? 'desc' : 'asc';
                }

                this.$axios.get('stores?' + createQueryString(params))
                    .then(response => {
                        this.loading = false;
                        this.stores = response.data['hydra:member'];
                        this.totalStores = response.data['hydra:totalItems'];
                    });
            },
            onStoreFiltersChanged(filters) {
                this.filters = {
                    'name': filters.store_name,
                    'email': filters.store_email,
                };
                this.load();
            },
        },

        watch: {
            queryString: {
                handler() {
                    this.load();
                }
            }
        },

        computed: {
            queryString: function () {
                let params = {page: this.options.page, ...this.$route.params, ...this.$route.query, ...this.filters, order: {}};
                return createQueryString(params);
            },
        },

        mounted() {
            this.load();
        }
    }
</script>
